const escapeHtml = (s: string) =>
  s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

// Enlaces internos escritos como [texto](/ruta/) (solo rutas internas que empiezan por "/")
const LINK_RE = /\[([^\]]+)\]\((\/[a-z0-9\-\/#]*)\)/gi;
const inline = (s: string) =>
  escapeHtml(s).replace(LINK_RE, (_m, t, href) => `<a href="${href}" class="text-yellow-600 underline hover:text-yellow-700">${t}</a>`);

// Quita el formato de enlace y deja solo el texto
export const stripLinks = (s: string) => s.replace(LINK_RE, '$1');

// Convierte el texto plano de los artículos (títulos numerados y listas con "-") en HTML
export const renderBlogContent = (text: string): string => {
  const out: string[] = [];
  let inList = false;
  const closeList = () => {
    if (inList) { out.push('</ul>'); inList = false; }
  };
  for (const raw of text.split('\n')) {
    const line = raw.trim();
    if (!line) { closeList(); continue; }
    if (line.startsWith('- ')) {
      if (!inList) { out.push('<ul class="list-disc pl-6 mb-4 space-y-1">'); inList = true; }
      out.push(`<li>${inline(line.slice(2))}</li>`);
    } else if (/^\d+\.\s/.test(line)) {
      closeList();
      out.push(`<h2 class="text-2xl font-bold mt-8 mb-3">${inline(line)}</h2>`);
    } else {
      closeList();
      out.push(`<p class="mb-4">${inline(line)}</p>`);
    }
  }
  closeList();
  return out.join('\n');
};

// Preguntas frecuentes del artículo (sección "Preguntas frecuentes") para el schema FAQPage
const FAQ_RE = /preguntas frecuentes|preguntes freq|faq|frequently asked|questions fr/i;
export const extractFaq = (text: string): { q: string; a: string }[] => {
  const faq: { q: string; a: string }[] = [];
  let inFaq = false;
  for (const raw of text.split('\n')) {
    const line = raw.trim();
    if (/^\d+\.\s/.test(line)) { inFaq = FAQ_RE.test(line); continue; }
    if (!inFaq || !line.startsWith('- ')) continue;
    const item = stripLinks(line.slice(2));
    const i = item.indexOf('?');
    if (i > 0 && i < item.length - 2) faq.push({ q: item.slice(0, i + 1).trim(), a: item.slice(i + 1).trim() });
  }
  return faq;
};
